const getDsSource = (t) => ({
    columns: [
        { column: '_no', title: t('report.columns.no'), width: '10%', thClassName: 'text-center', tdClassName: '', sort: true },
        { column: '_pub', title: t('report.columns.pub'), width: '15%', thClassName: 'text-center', tdClassName: '', sort: true },
        { column: '_leads', title: t('hsReport.columns.leads'), width: '15%', thClassName: 'text-center', tdClassName: '', sort: true },
        { column: '_aov', title: t('hsReport.columns.aov'), width: '15%', thClassName: 'text-center', tdClassName: '', sort: true },
        { column: '_approved', title: t('hsReport.columns.approved'), width: '15%', thClassName: 'text-center', tdClassName: '', sort: true },
        { column: '_validated', title: t('report.columns.validated'), width: '15%', thClassName: 'text-center', tdClassName: '', sort: true },
        { column: '_trash', title: t('hsReport.columns.trash'), width: '15%', thClassName: 'text-center', tdClassName: '', sort: true },
    ],
})

export { getDsSource }
